export const cardTextItems = [
  {
    id: 0,
    title: 'Lorem ipsum dolor sit amet, consectetur adipisc',
    textToShow:
      'Lorem ipsum dolor sit amet, consectetur adipiscLorem ipsum dolor sit amet, consectetur adipisc'
  },
  {
    id: 1,
    title: 'Lorem ipsum dolor sit amet',
    textToShow:
      'Lorem ipsum dolor sit amet, consectetur adipiscLorem ipsum dolor sit amet, consectetur adipisc',
    active: false
  },
  {
    id: 2,
    title: 'Lorem ipsum dolor sit amet',
    textToShow:
      'Lorem ipsum dolor sit amet, consectetur adipiscLorem ipsum dolor sit amet, consectetur adipisc',
    active: false
  },
  {
    id: 3,
    title: 'Lorem ipsum dolor sit amet',
    textToShow:
      'Lorem ipsum dolor sit amet, consectetur adipiscLorem ipsum dolor sit amet, consectetur adipisc',
    active: false
  }
]
